import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import api from '../lib/api';

const ContentContext = createContext({ content: {}, refresh: () => {} });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const refresh = useCallback(() => {
    api.get('/content').then((res) => setContent(res.data || {})).catch(() => {});
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const value = useMemo(() => ({ content, refresh }), [content, refresh]);
  return (
    <ContentContext.Provider value={value}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => {
  const { content, refresh } = useContext(ContentContext);
  const c = useCallback(
    (key, fallback = '') => {
      const v = content[key];
      return v === undefined || v === '' ? fallback : v;
    },
    [content]
  );
  return { c, refresh };
};
